import { useEffect } from 'react'
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getUserDetails } from "../redux/slices/AuthSlice"


const ProtectedRoute = ({ children }) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    // Fetch once on mount — not on every route change (avoids auth storms during navigation).
    useEffect(() => {
        if (user) {
            dispatch(getUserDetails());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
